import React, { useEffect, useState, useRef } from "react";
import "./iplbattle.css";
import ipl from "../../../assets/ipl/IPLWAR.svg";
import { FaArrowRight } from "react-icons/fa";
import useUserInfo from "../../../Hooks/useUserInfo";
import SelectTeamWithCard from "./selectTeamCard";
import { logPageView } from "../../../components/analytics";
import BattleLeaderBoard from "./LeaderBoard";
import Ufwfixuters from "../Iplbattle/iplpayoffs/IPLPlayoffs";

import {
  CountdownTimer,
  CountdownTimerForList,
  formatTimeRemaining,
  logoMap2,
} from "../../../helpers/helpers";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  getPrizePoolDetails,
  IplMatchData,
  MatchScheduleListApi,
  SquadListApi,
} from "../../../apis/iplBattle";
import Iplwar from "./ipllanding";
// import PrizePool from "./prizePool";
import CreateLeague from "./CreateLeague";
import JoinLeague from "./JoinLeague";
import IplInfo from "./Ipl-Info/Info";

const MatchScheduleList = () => {

  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [matchList, setMatchList] = useState([]);
  const [chosenTeam, setChosenTeam] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [battleId, setBattleId] = useState(null);
  const [prizePoolDetails, setPrizePoolDetails] = useState([]);
  const [SquadTeam, setSquadTeam] = useState([]);
  const IsPlayStarted = watchScreen?.currentBattleDetails?.selectedCard;
  const scrollableRef = useRef(null);
  const [activeSection, setActiveSection] = useState( watchScreen?.cricketLeague!=="ipl"?"section1":"section2");
  useEffect(() => {
    const preventTouchScroll = (event) => {
      // Allow scrolling only for the scrollable div
      if (!scrollableRef.current.contains(event.target)) {
        event.preventDefault();
      }
    };
    // Add the event listener
    document.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    // Cleanup the event listener
    return () => {
      document.removeEventListener("touchmove", preventTouchScroll);
    };
  }, []);
  const SliceSquadTeam = SquadTeam?.slice(0, 2);
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails?.currentComponent,
          lastComponentText: userDetails?.currentComponentText,
          centerCount: userDetails?.centerCount + 1,
        },
      };
    });
  };

  useEffect(() => {
    logPageView("UFW SCHEDULE PAGE", "UFW SCHEDULE PAGE");
  }, []);

  useEffect(() => {
    const shouldNavigateToSquadPage = localStorage.getItem(
      `navigateToSquadPage_${userDetails?.userDetails?.telegramId}`
    );
    if (shouldNavigateToSquadPage === "true") {
      localStorage.removeItem(
        `navigateToSquadPage_${userDetails?.userDetails?.telegramId}`
      );
      goToThePage(BattleLeaderBoard, "BattleLeaderBoard");
    }
  }, [userDetails?.userDetails?.telegramId]);

  useEffect(() => {
    const fetchMatchList = async () => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const result = await MatchScheduleListApi(watchScreen?.cricketLeague);
      const iplResult = await IplMatchData(
      watchScreen?.cricketLeague
      );
      const getSquad = await SquadListApi(userDetails?.userDetails?.telegramId);

      if (result) {
        setMatchList(result);
        updatewatchScreenInfo((prev) => ({
          ...prev,
          current_battle: result?.current_battle,
        }));
      } else {
        console.log("error in MatchScheduleList APi");
      }
      if (getSquad) {
        setSquadTeam(getSquad?.userSquads);
      } else {
        console.log("error in Squad APi");
      }
      if (iplResult) {
        setChosenTeam(iplResult);
      } else {
        console.log("error in Chosen APi");
      }
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    };

    fetchMatchList();
  }, []);

  const LiveBattleList = matchList?.current_battle;
  const UpcomingMatches = matchList?.upcoming_matches;
  const CompletedMatches = matchList?.completed_matches;
  const ChosenTeam = chosenTeam?.chosenTeam;

  const handleNavigate = () => {
    if (IsPlayStarted) {
      goToThePage(Iplwar, "Iplwar");
    } else {
      updatewatchScreenInfo((prev) => ({
        ...prev,
        current_battle: LiveBattleList,
        chosen_team_ipl: ChosenTeam,
      }));
      goToThePage(SelectTeamWithCard, "SelectTeamWithCard");
    }
  };
  const PrizePoolOpen = async (id) => {
    const response = await getPrizePoolDetails(
      userDetails?.userDetails?.telegramId,
      id
    );
    if (response) {
      setPrizePoolDetails(response);
      setOpenPopup(true);
      setBattleId(id);
    }
  };

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {!openPopup ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexDirection: "column",
            marginTop: "50px",
          }}
        >
          <div className="ipl-body container justify-content-center align-items-center">
            <div
              className="card text-white"
              style={{ maxWidth: "380px", width: "100%" }}
            >
              {/* TV Header */}

              {/* Main Content */}
              <div className="card-body p-0">
                <div className="text-center mb-0 p-2">
                  <div
                    className="bg-logo"
                    style={{
                      textAlign: "center",
                      // padding: "8px",
                      //   marginBottom: "8px",
                      //   background: "#121212",
                      //   borderBottom: "2px solid #0f0",
                    }}
                  >
                    <img
                      style={{ marginTop: "15px" }}
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/fanwarlogo.png"
                    />
                  </div>
                </div>
                {/* Title */}

                <div className="iplcontainer">
                  {/* Live Match */}

                  <div className="px-1 mb-3" style={{ width: "98%" }}>
                    <Slider {...sliderSettings}>
                      {/* First Slide */}
                      {LiveBattleList?.teams && (
                        <div className="iplcard bg-ipl mb-1 mx-1">
                          <div className="card-body p-2">
                            <div className="position-relative">
                              <span className="position-absolute sch-status">
                                <span className="spinner-grow spinner-grow-sm"></span>{" "}
                                LIVE
                              </span>
                              <div className="d-flex justify-content-around align-items-end">
                                <div className="text-center1">
                                  <img
                                    style={{ width: "40px" }}
                                    src={LiveBattleList?.teams?.[0]?.teamLogo}
                                    alt="CSK"
                                    className="mb-1"
                                  />
                                  <h3 className="teamname">
                                    {LiveBattleList?.teams?.[0]?.teamName}
                                  </h3>
                                </div>
                                <h6 className="schvs">VS</h6>
                                <div className="text-center1">
                                  <img
                                    style={{ width: "40px" }}
                                    src={
                                     LiveBattleList?.teams?.[1]?.teamLogo
                                    }
                                    alt="PBKS"
                                    className="mb-1"
                                  />
                                  <h3 className="teamname">
                                    {LiveBattleList?.teams?.[1]?.teamName}
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="text-left p-1 bgipldate"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                            onClick={handleNavigate}
                          >
                            <h4>
                              ENDS IN:
                              <CountdownTimerForList
                                enddate={LiveBattleList?.endDate}
                              />
                            </h4>
                            <FaArrowRight className="arrow-icon" />
                          </div>
                        </div>
                      )}

                      {/* Second Slide - Duplicate of first slide for demo */}
                      {SliceSquadTeam?.length > 0 && (
                        <div>
                          <div className="iplcard bg-ipl mb-1 mx-1 createsquad p-2 code-box2">
                            <div className="row display-squad pb-1">
                              <div className="col-6">
                                <p className="text-justify">My leagues</p>
                              </div>
                              <div className="col-6 text-right">
                                <button
                                  className="btn-cre"
                                  onClick={() => {
                                    goToThePage(CreateLeague, "CreateLeague");
                                  }}
                                >
                                  Create league
                                </button>
                              </div>
                            </div>
                            {SliceSquadTeam?.map((el) => {
                              return (
                                <div className="row display-squad pb-1 bg-black">
                                  <div className="col-6">
                                    <p className="text-justify">
                                      {el?.squadName}
                                    </p>
                                  </div>
                                  <div className="col-6 text-right">
                                    <p>{el?.userRank}</p>
                                  </div>
                                </div>
                              );
                            })}
                            {/* <div className="row display-squad pb-1 bg-black">
                          <div className="col-6">   
                            <p className="text-justify">Marma</p>
                          </div>
                          <div className="col-6 text-right">
                          <p>1</p>
                          </div>
                        </div> */}
                            <div className="row">
                              <div
                                className="col-12 text-center"
                                onClick={() => {
                                  goToThePage(
                                    BattleLeaderBoard,
                                    "BattleLeaderBoard"
                                  );
                                }}
                              >
                                <p className="view-all">{"View All >>"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/*Third Slider*/}
                      <div>
                        <div className="iplcard bg-ipl mb-1 mx-1 squad code-box1">
                          <h4>challenge friends</h4>
                          <p>
                            Create a private league with your friends for the
                            whole series or daily match{" "}
                          </p>
                          <div className="flexsquad">
                            <button
                              className="btn-light text-uppercase"
                              onClick={() => {
                                goToThePage(JoinLeague, "joinleague");
                              }}
                            >
                              Join league
                            </button>
                            <button
                              onClick={() => {
                                goToThePage(CreateLeague, "CreateLeague");
                              }}
                              className="btn-dark text-uppercase"
                            >
                              Create league{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </div>

                  <div className="container mt-1 px-3">
                    <div className="mb-2 dis-refer">
                    {watchScreen?.cricketLeague!=="ipl"&&(
                      <button
                        className={`text-uppercase btn-${
                          activeSection === "section1"
                            ? "primaryipl"
                            : "outline-primary1"
                        } me-2`}
                        onClick={() => setActiveSection("section1")}
                      >
                        Upcoming
                      </button>)}
                      <button
                        className={`text-uppercase  btn-${
                          activeSection === "section2"
                            ? "primaryipl"
                            : "outline-primary1"
                        }`}
                        onClick={() => setActiveSection("section2")}
                      >
                        Completed
                      </button>
                    </div>

                    {activeSection === "section1" && watchScreen?.cricketLeague!=="ipl" && (
                      <div
                        ref={scrollableRef}
                        className={`${
                          LiveBattleList?.length == 0
                            ? " scrollableipl "
                            : "scrollableipllive"
                        } `}
                      >
                        <div>
                          {/* <h4
                            style={{ fontFamily: "press", fontSize: "1rem" }}
                            className="text-uppercase text-center mt-2 mb-2"
                            onClick={() => {
                              goToThePage(Ufwfixuters, "Ufwfixuters");
                            }}
                          >
                            UFW Playoffs
                          </h4> */}
                        </div>
                        {UpcomingMatches?.map((item, index) => (
                          <div key={index} className="">
                            <div className="iplcard bg-iplcomp mb-1">
                              <div className="card-body p-2">
                                <div className="position-relative">
                                  {/* <span className=" position-absolute sch-statusupcome text-black">
                           UPCOMING
                         </span> */}
                                  <div className="d-flex justify-content-around align-items-end">
                                    <div className="text-center">
                                      <img
                                        style={{ width: "40px" }}
                                        src={item?.teams?.[0]?.teamLogo}
                                        alt="CSK"
                                        className="mb-1"
                                      />
                                      <h3 className="teamname">
                                        {item?.teams?.[0]?.teamName}
                                      </h3>
                                    </div>
                                    <h6 classname="schvs-upcoming">VS</h6>
                                    <div className="text-center">
                                      <img
                                        style={{ width: "40px" }}
                                        // src={item?.teams?.[1]?.teamLogo}
                                        src={
                                          item?.teams?.[1]?.teamLogo
                                        }
                                        alt="PBKS"
                                        className="mb-1"
                                      />
                                      <h3 className="teamname">
                                        {item?.teams?.[1]?.teamName}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center p-1 bgipldatecomp text-uppercase">
                                <h4>
                                  STARTS IN:{" "}
                                  <CountdownTimerForList
                                    enddate={item?.startDate}
                                  />
                                </h4>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {activeSection === "section2" && (
                      <div
                        ref={scrollableRef}
                        className={`${
                          LiveBattleList?.length == 0
                            ? " scrollableipl "
                            : "scrollableipllive"
                        } `}
                      >
                        {CompletedMatches?.length > 0 ? (
                          <>
                            {CompletedMatches?.map((item, index) => (
                              <div
                                key={index}
                                className=""
                                // onClick={() => PrizePoolOpen(item?._id)}
                              >
                                <div className="iplcard bg-iplcomp mb-1">
                                  <div className="card-body p-2">
                                    <div className="position-relative">
                                      {/* <span className=" position-absolute sch-statusupcome text-black">
                              UPCOMING
                            </span> */}
                                      <div className="d-flex justify-content-around  align-items-center">
                                        <div className="text-center">
                                          <img
                                            style={{ width: "40px" }}
                                            src={item?.teams?.[0]?.teamLogo}
                                            alt="CSK"
                                            className="mb-1"
                                          />
                                          <h3 className="teamname">
                                            {item?.teams?.[0]?.teamName}
                                          </h3>
                                        </div>
                                        <h6 classname="schvs-upcoming">VS</h6>
                                        <div className="text-center">
                                          <img
                                            style={{ width: "40px" }}
                                            // src={item?.teams?.[1]?.teamLogo}
                                            src={
                                             item?.teams?.[1]?.teamLogo
                                            }
                                            alt="PBKS"
                                            className="mb-1"
                                          />
                                          <h3 className="teamname">
                                            {item?.teams?.[1]?.teamName}
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-center p-1 bgipldatecomp text-uppercase">
                                    {item?.draw ? (
                                      <h4> It's a Draw Match</h4>
                                    ) : (
                                      <h4>
                                        {" "}
                                        {item?.winTeam} won by {item?.wonBy}{" "}
                                        runs
                                      </h4>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div className="iplcard bg-iplcomp mb-1">
                            <div className="text-center p-1 bgipldatecomp text-uppercase">
                              <h4>No matches Found</h4>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Upcoming Matches */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <IplInfo setOpenPopup={setOpenPopup} />
      )}
    </>
  );
};

export default MatchScheduleList;
